const CONTENT_BY_SITE_ID = {
  MLA: 'S-6uvW-Tz2uCPSKaInUV-QC-6tf1eTZDepKhXv9vhv4',
  MLB: 'T-I7t725DJsbR4--_7qN12s4GG2eOCzBPrzH3-ZBhvc',
  MLM: 'vIkj4ZNATUG_QLLRIpEBN662G6SVN95o_03THQB48a0',
};

module.exports = {
  getContent: siteId => (CONTENT_BY_SITE_ID[siteId] || ''),
};
